import React from 'react'
import { Button } from 'react-weui'
import { connect } from 'react-redux'
import axios from 'axios'
import { renderMoney } from '../../utils'
import { setEvent } from '../../services';


class ChannelGroupBuyBottomBtn extends React.Component {
    onClickOriginBuy () {
        const {channel, discount, newCoupon} = this.props;

        if ((discount && discount.price) || (newCoupon.hasCoupon && newCoupon.canUseCouponBuy)) {
            this.props.dispatch({
                type: 'CHANNEL_SHOW_PAY_PANEL'
            });
            if (this.props.newCoupon.couponData){
                this.props.dispatch({
                    type: 'CHANNEL_SET_DISCOUNT',
                    payload: this.props.newCoupon.couponData
                })
            }
        } else {
            setEvent({name: 'wk_group-pay-channel-origin'})
            this.props.dispatch({
                type: 'PAY_CHANNEL',
                payload: {
                    params: {
                        product: 'pay_channel',
                        channel_id: channel.id,
                    },
                    success: () => {
                        location.assign(`/channel/${channel.id}/paysuccess${location.search}`)
                    },
                }
            })
        }
    }

    onClickGroupBuy () {
        setEvent({name: 'wk_group-pay-channel-buy'})
        this.props.dispatch({
            type: 'PAY_CHANNEL',
            payload: {
                params: {
                    product: 'pay_channel_groupbuy',
                    group_id: this.props.groupBuy.id,
                    activity_id: 0
                },
                success: (data) => {
                    location.assign(`/channel/group_buy?id=${data.data.activity_id}&show_dialog=1`)
                },
            }
        })
    }

    render() {
        const { groupBuyAccess, groupBuy, channel } = this.props
        return (
            <div className="channel-group-buy-bottom-btn-wrap">
                {
                    groupBuyAccess && (
                        <Button 
                            className="weui-flex__item flex_3 " 
                            onClick={e => location.assign(`/channel/group_buy?id=${groupBuyAccess.group_activity_id}`)}
                        >
                            查看我的拼团
                        </Button>
                    )
                }
                {
                    !groupBuyAccess && (
                        <div className='no-join-group-btn-wrap'>
                            <Button className="weui-flex__item no-join-group-btn" onClick={e => this.onClickOriginBuy()}>
                                原价购买<br /> <span className='big'>￥{renderMoney(channel.money)}</span>
                            </Button>
                            <Button className="weui-flex__item no-join-group-btn" onClick={e => this.onClickGroupBuy()}>
                                {groupBuy.group_num}人拼团<br /> <span className='big'>￥{renderMoney(groupBuy.price)}</span>
                            </Button>
                        </div>
                        
                    )
                }
            </div>
        )
    }
}


export default connect(state => ({
    discount: state.channel.discount,
    newCoupon: state.newCoupon,
}))(ChannelGroupBuyBottomBtn)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelGroupBuyBottomBtn.js